import { HorizontalBar } from 'vue-chartjs'

export default {
    extends: HorizontalBar,
    props: ['chartData','options'],
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
}